import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../cmsHooks/useIndexPageData'

import { SectionHeader } from '../../ui'
import { FullWidthSection, ContentContainer } from '../../layout'

import FAQ from './faq/FAQ'
import Clients from './faq/Clients'

const FaqLayout = styled.div`
  display: grid;
  grid-template-columns: 60% 40%;
  column-gap: 40px;
`

const FaqContainer = styled.section``
const ClientsContainer = styled.section``

const FaqSection = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <FullWidthSection>
      <ContentContainer>
        <FaqLayout>
          <FaqContainer>
            <SectionHeader>
              <CMS.Text name="FAQ headline" data={data} />
            </SectionHeader>
            <FAQ />
          </FaqContainer>
          <ClientsContainer>
            <Clients />
          </ClientsContainer>
        </FaqLayout>
      </ContentContainer>
    </FullWidthSection>
  )
}

export default FaqSection
